export const ApiURL = process.env.REACT_APP_NODE_ENV == "development" ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL_PRODUCTION;
export const ApiMediaURL = process.env.REACT_APP_NODE_ENV == "development" ? process.env.REACT_APP_API_MEDIA_URL : process.env.REACT_APP_API_MEDIA_URL_PRODUCTION;;


